import { ProductsTypeEnum } from '@app/forms/subscription/definition/interface/question.interface';

export interface ProductSubscriptionFlows {
  subscriptionSendMailAllowed?: boolean;
  subscriptionFluxAllowed?: boolean;
}

export function isFullScopeAllowed(
  productType: ProductsTypeEnum,
  product: ProductSubscriptionFlows | undefined,
  operation: string,
): boolean {
  if (operation !== 'SUBSCRIPTION' || productType === ProductsTypeEnum.SCPI) {
    return true;
  }
  return !(product?.subscriptionSendMailAllowed === false && product?.subscriptionFluxAllowed === false);
}
